// import auth from './auth'
// import {setDomain, getSystemTime} from '../api'

// setDomain('/admin')

// let systemTime, getTime
// getSystemTime().then(sysTime => {
//     getTime = new Date().getTime()
//     systemTime = sysTime
// })
let systemTime, getTime
getTime = new Date().getTime()
systemTime = getTime


export default {
    // 将long类型的时间转换成2018-05-09格式
    formatDate(timestamp) {
        if (timestamp !== '') {
            var now = new Date(timestamp)
            var year = now.getFullYear()
            var month = now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : now.getMonth() + 1
            var date = now.getDate() < 10 ? '0' + now.getDate() : now.getDate()
            return `${year}-${month}-${date}`
        } else {
            return ''
        }
    },
    // 将long类型的时间转换成2018-05-09 00:00格式
    formatTime(timestamp, noSeconds) {
        if (timestamp !== '') {
            var now = new Date(timestamp)
            var year = now.getFullYear()
            var month = now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : now.getMonth() + 1
            var date = now.getDate() < 10 ? '0' + now.getDate() : now.getDate()
            var hour = now.getHours() < 10 ? '0' + now.getHours() : now.getHours()
            var min = now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes()
            if (noSeconds) {
                return `${year}-${month}-${date} ${hour}:${min}`
            }
            var second = now.getSeconds() < 10 ? '0' + now.getSeconds() : now.getSeconds()
            return `${year}-${month}-${date} ${hour}:${min}:${second}`
        } else {
            return ''
        }
    },
    // 将long类型的时间转换成2019-12-25T01:20:22.340+0800格式
    formatJsonTime(timestamp) {
        if (timestamp !== '') {
            var now = new Date(timestamp)
            var year = now.getFullYear()
            var month = now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : now.getMonth() + 1
            var date = now.getDate() < 10 ? '0' + now.getDate() : now.getDate()
            var hour = now.getHours() < 10 ? '0' + now.getHours() : now.getHours()
            var min = now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes()
            var second = now.getSeconds() < 10 ? '0' + now.getSeconds() : now.getSeconds()
            var ms = now.getMilliseconds < 10 ? '00' + now.getMilliseconds() : now.getMilliseconds() < 100 ? '0' + now.getMilliseconds() : now.getMilliseconds()
            return `${year}-${month}-${date}T${hour}:${min}:${second}.${ms}+0800`
        } else {
            return ''
        }
    },
    // 格式化时间为带单位的时间（默认是秒）
    formatTimeWithUnit(time, maxUnit) {
        if (time === null || time === undefined) {
            return ''
        }
        if (typeof time !== 'number') {
            time = parseFloat(time)
        }
        if (!isNaN(time)) {
            let timeStr = ''
            const hour = maxUnit === 'hour' ? parseInt(time / 3600) : 0
            const min = parseInt((time - hour * 3600) / 60)
            const second = (time - hour * 3600 - min * 60)

            if (hour) {
               timeStr += hour + '时' 
            }
            if (min) {
                timeStr += min + '分' 
            }
            timeStr += second + '秒'
            return timeStr
        } else {
            return ''
        }
    },
    validatePhoneFormat(phone) {
        /* if(!(/^1[3456789]\d{9}$/.test(phone))) {
            return false
        } */
        if (!/^1\d{10}$/.test(phone)) {
            return false
        }
        return true
    },
    
    validateMailFormat(mail) {
        if (!/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(mail)) {
            return false
        }
        return true
    },
    // goToRegister(_router) {
    //     auth.stopCheckQrStatusTimer()
    //     auth.stopQrcodeOverdue()
    //     _router.push('/enterpriseRegister')
    // },
    // 根据节点类型返回节点对应的图标名称
    getNodeIcon(type) {
        switch (type) {
            case 1:
                return 'enterprise'
            case 0:
                return 'sector'
            case 3:
                return 'childzz'
            default:
                return 'staff'
        }
    },
    // 获取节点的部门路径
    getSectorPath(pathStr, type) {
        if (!pathStr) {
            return
        }
        let path = pathStr.split('>')
        let endPos = 1
        // 如果是部门，需要截取掉自己
        if (type === 1) {
            endPos = 2
        }

        path.splice(path.length - endPos, endPos)

        return path.join(' > ')
    },
    oneMinuteCountDown(vm) {
        vm.showTimeCounter = true
        const countDownTimer = setInterval(function() {
            vm.timeCounter--
            if (vm.timeCounter < 0) {
                // 显示重新获取验证码按钮，重置倒计时
                clearInterval(countDownTimer)
                vm.timeCounter = 59
                if (vm.butText) {
                    vm.butText = '重新发送'
                }
                vm.showTimeCounter = false
            }
        }, 1000)
        return countDownTimer
    },
    humpToUnderLine(str, isLower) {
        let upperIndex = []
        for (let i = 0; i < str.length; i++) {
            if (str.charCodeAt(i) < 90) {
                upperIndex.push(i)
            }
        }
        let isStartWithUpper = false
        upperIndex.forEach(function(uIndex, index) {
            if (uIndex === 0) {
                isStartWithUpper = true
            } else {
                const i = isStartWithUpper ? uIndex + index - 1 : uIndex + index
                str = str.substring(0, i) + '_' + str.substring(i, str.length)
            }
        })

        return isLower ? str.toLowerCase() : str.toUpperCase()
    },
    testSpecialChar(rule, str, callback) {
        var pattern = new RegExp('[\\\\<>/\\|]')

        if (pattern.test(str)) {
            if (callback) {
                callback(new Error('不能含有特殊字符/\\<>|'))
            } else {
                return false
            }
        } else {
            if (callback) {
                callback()
            } else {
                return true
            }
        }
    },

    /* 用正则表达式实现html编码（转义）*/
    htmlEncodeByRegExp: function(str) {
        let temp = ''
        if (str.length == 0) return ''
        temp = str.replace(/&/g, '&amp;')
        temp = temp.replace(/</g, '&lt;')
        temp = temp.replace(/>/g, '&gt;')
        temp = temp.replace(/\s/g, '&nbsp;')
        temp = temp.replace(/'/g, '&#39;')
        temp = temp.replace(/"/g, '&quot;')
        return temp
    },

    /* 用正则表达式实现html解码（反转义）*/
    htmlDecodeByRegExp: function(str) {
        let temp = ''
        if (str.length == 0) return ''
        temp = str.replace(/&amp;/g, '&')
        temp = temp.replace(/&lt;/g, '<')
        temp = temp.replace(/&gt;/g, '>')
        temp = temp.replace(/&nbsp;/g, ' ')
        temp = temp.replace(/&#39;/g, "'")
        temp = temp.replace(/&quot;/g, '"')
        return temp
    },

    hiddenPartOfMobileNumber: function(mobile) {
        if (mobile && mobile.length > 7) {
            return mobile.substring(0, mobile.length - 8) + '****' + mobile.substring(mobile.length - 4, mobile.length)
        }
        return mobile
    },
    getSystemTime: function() {
        if (!systemTime) {
            return new Date().getTime()
        }
        const currentTime = new Date().getTime()
        return systemTime + (currentTime - getTime)
    },
    //去空格
    Trim(str) {
        return str.replace(/(^\s*)|(\s*$)/g, '')
    },
    remoteSelectFocus(event, callback) {
        event.srcElement.nextElementSibling.firstChild.firstChild.classList.remove('el-icon-')
        event.srcElement.nextElementSibling.firstChild.firstChild.classList.add('el-icon-search')
        if (callback) {
            callback()
        }
    },
    remoteSelectBlur(event) {
        event.srcElement.nextElementSibling.firstChild.firstChild.classList.remove('el-icon-search')
        event.srcElement.nextElementSibling.firstChild.firstChild.classList.add('el-icon-')
    },

    formatNumber(num) {
        let numStr = (num || 0).toString(),
            result = ''
        let suffix = ''
        if (numStr.indexOf('.') > -1) {
            const numList = numStr.split('.')
            numStr = numList[0]
            suffix = numList[1]
        }
        while (numStr.length > 3) {
            result = ',' + numStr.slice(-3) + result
            numStr = numStr.slice(0, numStr.length - 3)
        }
        if (numStr) {
            result = numStr + result
        }
        if (suffix) {
            result += '.' + suffix
        }
        return result
    }
}



// WEBPACK FOOTER //
// ./src/utils/tools.js